import { render, staticRenderFns } from "./ejectionForm.vue?vue&type=template&id=30044d65&scoped=true"
import script from "./ejectionForm.vue?vue&type=script&lang=js"
export * from "./ejectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30044d65",
  null
  
)

export default component.exports